<template>
  <div>
    <b-card>
      <b-tabs content-class="mt-3">
        <!-- Aba: Dados Básicos -->
        <b-tab
          :title="$t('reporting_channel.workflow_config.basic_tab')"
          active
        >
          <basic-data-tab :id="id" @saved="handleSaved" />
        </b-tab>

        <!-- Aba: Configuração de Prazos -->
        <b-tab
          :title="$t('reporting_channel.workflow_config.deadlines_tab')"
          :disabled="!id"
        >
          <deadline-config-tab :id="id" :workflow-config-id="id" />
        </b-tab>

        <!-- Aba: Destinatários -->
        <b-tab
          :title="$t('reporting_channel.workflow_config.destinations_tab')"
          :disabled="!id"
        >
          <destinatarios-tab :id="id" />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import { BCard, BTabs, BTab } from 'bootstrap-vue'
import BasicDataTab from './BasicDataTab.vue'
import DeadlineConfigTab from './DeadlineConfigTab.vue'
import DestinatariosTab from './DestinatariosTab.vue'

export default {
  components: {
    BCard,
    BTabs,
    BTab,
    BasicDataTab,
    DeadlineConfigTab,
    DestinatariosTab
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  methods: {
    handleSaved(savedId) {
      // Se salvou uma nova configuração, atualiza a rota
      if (!this.id && savedId) {
        this.$router.replace({
          name: 'handling_status_configuration_edit',
          params: { id: savedId }
        })
      }
    }
  }
}
</script>

<style scoped></style>
